export const SORTBY_FILTER_SHORT_NAME = "sortBy"
export const sortByDefault = 'default'

const sN = SORTBY_FILTER_SHORT_NAME
const sD = sortByDefault

export const SORTBY_FILTER_CONFIG = {
  short_name: sN,
  default_values: sD,
  is_default: value => testSortByDefault(value), //right before clean up
  format_to_api: value => formatSortByForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatSortByFromURL(value) //
}


//we just do this for nice semantic names
export const testSortByDefault = value => {
  return isSortByDefault(value)
}


export const isSortByDefault = (value) => {
  return value === sortByDefault
}

export const sortByLabel = () => {
  return [
    {key: 'default', value: 'Default'},
    {key: 'low_to_high', value: 'Daily price: low to high'},
    {key: 'high_to_low', value: 'Daily price: high to low'},
    {key: 'distance_away', value: 'Distance away'},
  ]
}

export const sortByOptions = [
  {
    key: "default",
    text: "Default",
    value: "default",
    content: "Default"
  },
  {
    key: "low_to_high",
    text: "Daily price: low to high",
    value: "low_to_high",
    content: "Daily price: low to high"
  },
  {
    key: "high_to_low",
    text: "Daily price: high to low",
    value: "high_to_low",
    content: "Daily price: high to low"
  },
  {
    key: "distance_away",
    text: "Distance away",
    value: "distance_away",
    content: "Distance away"
  }
]


export const formatSortByFromURL = value => {
  return formattedValue(value)
}

//api
export const formatSortByForAPI = (value) => {
  return formattedValue(value)
}

const formattedValue = (camelStr) => {
  let stringValue  = camelStr
  if (camelStr instanceof Object) {
    const { sort_by } = camelStr
    stringValue = sort_by
  }
  if (stringValue) {
    return {
      sort_by: stringValue
    }
  } else {
    return {}
  }
}
